import { ThunkAction } from 'redux-thunk';
import { Action } from 'redux';
import { State as RootState } from '../../../app/redux/types';
import {
  FETCH_ONESCHEMA_TOKEN_REQUEST,
  FETCH_ONESCHEMA_TOKEN_SUCCESS,
  FETCH_ONESCHEMA_TOKEN_FAILURE,
  DataOnboardingActionTypes,
} from './types';
import { fetchOneSchemaPlatformToken } from '../api';

export const fetchOneSchemaTokenRequest = (): DataOnboardingActionTypes => ({
  type: FETCH_ONESCHEMA_TOKEN_REQUEST,
});

export const fetchOneSchemaTokenSuccess = (
  token: string
): DataOnboardingActionTypes => ({
  type: FETCH_ONESCHEMA_TOKEN_SUCCESS,
  payload: token,
});

export const fetchOneSchemaTokenFailure = (
  error: string
): DataOnboardingActionTypes => ({
  type: FETCH_ONESCHEMA_TOKEN_FAILURE,
  payload: error,
});

// Thunk action to fetch the token
export const fetchOneSchemaToken =
  (): ThunkAction<void, RootState, unknown, Action<string>> =>
  async (dispatch) => {
    dispatch(fetchOneSchemaTokenRequest());
    try {
      const token = await fetchOneSchemaPlatformToken();
      const expiresInMinutes = 15;
      const expiryTime = new Date().getTime() + expiresInMinutes * 60 * 1000;
      try {
        localStorage.setItem('oneSchemaJwt', token);
        localStorage.setItem('oneSchemaJwtExpiry', expiryTime.toString());
      } catch (storageError) {
        console.warn(
          'Failed to store OneSchema token in localStorage:',
          storageError
        );
      }
      dispatch(fetchOneSchemaTokenSuccess(token));
    } catch (error) {
      const errorMessage =
        error instanceof Error
          ? error.message
          : 'Failed to fetch OneSchema token';
      dispatch(fetchOneSchemaTokenFailure(errorMessage));
    }
  };
